
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getActionLog } from '@/api/gcash/account'
import { delObjEmptyKey, parseTime } from '@/utils'
import { getCurrentDate, dateToSeconds, pickerOptions } from '@/utils/dateTime'

const initDate = getCurrentDate()
@Component({
  name: 'ActionLog',
  components: {},
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    },
  },
})
export default class extends Vue {
  @Prop({ required: true }) info!: any

  private queryForm: any = {
    account_no: this.info.account_no,
    start_time: initDate[0],
    end_time: initDate[1],
    type: '',
  }
  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }
  private date: any[] = getCurrentDate()
  private pickerOptions: any = pickerOptions

  private logList: any[] = []
  private listLoading: boolean = false
  private total = 0

  private promptLoading: boolean = false

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      await getActionLog(data).then((res: any) => {
        this.logList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.logList = []
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      account_no: this.info.account_no,
      start_time: initDate[0],
      end_time: initDate[1],
      type: '',
    }
    // let el:any = this.$refs.myTable
    // el.clearSort()
    this.currentPage = 1
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  private changeUnlock() {}

  private async init() {
    await this.hadleGetFilesListApi()
  }

  mounted() {
    this.init()
  }
}
